module.exports = __webpack_public_path__ + "static/media/yesbitLogoWithBG.f90aed47.png";